module.exports = __webpack_public_path__ + "img/home_selected.bd26451a.png";